import SizeHelpers from './size-helpers';
import { QuantityHelpers } from './quantity-helpers';

const sizesWithPrints = sizes => {
  return sizes.filter(SizeHelpers.sizeHasPrints);
};

const sizesWithRootImage = (sizes, imageID) => {
  return sizes.filter(size => SizeHelpers.sizeHasRootImage(size, imageID));
};

const quantityForSize = size => {
  return QuantityHelpers.quantityForSize(size);
};

const priceAtQuantityForSize = (
  size,
  deliveryOption,
  fallbackToQuantityOfOne
) => {
  return QuantityHelpers.priceAtQuantityForSize(
    size,
    deliveryOption,
    fallbackToQuantityOfOne
  );
};

const totalPrice = (sizes, deliveryOption) => {
  return sizesWithPrints(sizes).reduce(
    (memo, size) =>
      memo +
      priceAtQuantityForSize(size, deliveryOption) * quantityForSize(size),
    0
  );
};

const totalQuantity = sizes => {
  return sizesWithPrints(sizes).reduce(
    (memo, size) => memo + quantityForSize(size),
    0
  );
};

const sizesWithPrice = (availableSizes, sizes, deliveryOption) => {
  return availableSizes.map(availableSize => {
    const size = sizes.reduce((acc, currentSize) => {
      return currentSize.key === availableSize.key ? currentSize : acc;
    }, availableSize);

    return {
      ...availableSize,
      price: priceAtQuantityForSize(size, deliveryOption, true),
    };
  });
};

export {
  sizesWithRootImage,
  sizesWithPrice,
  totalQuantity,
  totalPrice,
  sizesWithPrints,
  quantityForSize,
  priceAtQuantityForSize,
};
